import { legacyHttp } from '@noor/api';
import {
  vendorBroadcastListSchema,
  unreadBroadcastCountSchema,
  type VendorBroadcast,
  type VendorBroadcastStatus,
} from '../model/schema';

/** The accept/reject transition the card offers on actionable broadcasts. */
export interface RespondToBroadcastInput {
  status: 'accepted' | 'rejected';
  rejectReason?: string | undefined;
}

/** The old panel's list page size, verbatim. */
const BROADCASTS_PAGE_SIZE = 50;

export const vendorBroadcastApi = {
  /** The vendor's broadcasts, newest first, optionally filtered by status. */
  async list(status?: VendorBroadcastStatus): Promise<VendorBroadcast[]> {
    const raw = await legacyHttp.get<unknown>('vendors/broadcasts', {
      limit: BROADCASTS_PAGE_SIZE,
      skip: 0,
      ...(status === undefined ? {} : { status }),
    });
    return vendorBroadcastListSchema.parse(raw ?? []);
  },

  /** Fresh + action-pending count for the header badge. */
  async unreadCount(): Promise<number> {
    const raw = await legacyHttp.get<unknown>('vendors/broadcasts/unread-count');
    return unreadBroadcastCountSchema.parse(raw).count;
  },

  markViewed: (id: number): Promise<unknown> =>
    legacyHttp.patch(`vendors/broadcasts/${id}/viewed`),

  respond: (id: number, input: RespondToBroadcastInput): Promise<unknown> =>
    legacyHttp.patch(`vendors/broadcasts/${id}/respond`, {
      status: input.status,
      ...(input.status === 'rejected' ? { reject_reason: input.rejectReason ?? '' } : {}),
    }),

  /** The attachment bytes; the filename comes from `broadcastDownloadName`. */
  downloadFile: (path: string): Promise<Blob> =>
    legacyHttp.getBlob('file-uploads', { query: { path } }),
};
